import * as React from 'react';

import { Results } from '../../components/Results';
import { useSelector } from 'react-redux';
import { selectResults } from '../../selectors/results';
import { FoldersListContainer } from '../FoldersList';
import { EEntityType } from '../../types/filters';
import { selectFilters } from '../../selectors/filters';
import { FolderHeaderContainer } from '../FolderHeader';
import { TopBarContainer } from '../TopBar';

export function ResultsContainer() {
  const results = useSelector(selectResults);
  const { favoriteEntityType } = useSelector(selectFilters);
  const isFoldersListVisible = favoriteEntityType !== EEntityType.Newbuilding;

  return (
    <Results
      results={results}
      foldersList={isFoldersListVisible && <FoldersListContainer />}
      foldersHeader={isFoldersListVisible && <FolderHeaderContainer />}
      topBar={<TopBarContainer />}
    />
  );
}
